module.exports = __webpack_public_path__ + "img/sttrjf.159a280e.jpg";